import { useEffect } from 'react';

import 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import './CookieConsent.css';

export default function CookieConsent(props) {

	const { handleDisclaimerAgreed, setLoaderVisible, DEFAULT_LANG, language } = props;

	useEffect(() => {
		if (language) {
			setLoaderVisible(false);

			const langCode = language['language:code'] || DEFAULT_LANG;
			if (!document.getElementById('cc--main')) {
				window.CookieConsentApi = window.initCookieConsent();
				window.CookieConsentApi.run({
					current_lang: langCode,
					force_consent: true,
					cookie_name: 'consent_choice',
					cookie_expiration: 180,
					gui_options: {
						consent_modal: {
							layout: 'box',
							position: 'middle center',
							transition: 'slide',
							swap_buttons: false
						},
						settings_modal: {
							layout: 'box',
							transition: 'slide'
						}
					},
					onAccept: () => {
						//setLoaderVisible(true);
						handleDisclaimerAgreed(true);
					},
					languages: {
						langCode: {
							consent_modal: {
								title: language['disclaimer:header'],
								description: `
									<p>${language['disclaimer:description']} <a target="_blank" href="${language['disclaimer:policy_link:url']}">${language['disclaimer:policy_link:title']}</a></p>
									<br>
									<p class="link-wrapper"><a data-cc="c-settings" class="cc-link">${language['disclaimer:button:advanced']}</a></p>
								`,
								primary_btn: {
									text: language['disclaimer:button:agree'],
									role: 'accept_all' // 'accept_selected' or 'accept_all'
								},
								secondary_btn: {
									text: language['disclaimer:button:necessary'],
									role: 'accept_necessary' // 'settings' or 'accept_necessary'
								}
							},
							settings_modal: {
								title: language['disclaimer:advanced:title'],
								save_settings_btn: language['disclaimer:button:save_services'],
								accept_all_btn: language['disclaimer:button:agree'],
								reject_all_btn: false,
								close_btn_label: language['disclaimer:button:close'],
								blocks: [{
									title: '',
									description: `${language['disclaimer:advanced:description']} <a target="_blank" href="${language['disclaimer:policy_link:url']}">${language['disclaimer:policy_link:title']}</a>.`
								}, {
									title: language['disclaimer:services:mapbox:title'],
									description: language['disclaimer:services:mapbox:description'],
									toggle: {
										value: 'necessary',
										enabled: true,
										readonly: true
									}
								}]
							}
						},
					}
				});
			}
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [language]);

	return null;
}